import { memo } from 'react'

import { getContactInitials } from '../../lib/helpers'

import styles from './ContactAvatar.module.scss'

type ContactAvatarProps = {
  photo?: string
  firstName?: string
  lastName?: string
  email?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export const ContactAvatar = memo<ContactAvatarProps>(
  ({ photo, firstName, lastName, email, size = 'md', className }) => {
    const initials = getContactInitials({ firstName, lastName, email })

    return (
      <div
        className={`${styles.avatar} ${styles[size]} ${className || ''}`}
        style={photo ? { backgroundImage: `url(${photo})` } : undefined}
      >
        {!photo ? initials : null}
      </div>
    )
  }
)

ContactAvatar.displayName = 'ContactAvatar'
